module.exports = __webpack_public_path__ + "static/german_gurov_photo-432e20b86dfea433af10d879d4ab6441.png";